export enum CacheProperty {
    id_token = 'regexpert_id_token',
    access_token = 'regexpert_access_token',
    refresh_token = 'regexpert_refresh_token',
    is_returning_user = 'regexpert_is_returning_user',
    lesson_progress = 'regexpert_lesson_progress',
    guest_id = 'regexpert_guest_id',
}